export default "__VITE_ASSET__D8LG6Koe__"